import React, { useState } from 'react'
import "./DeactivatedPage.css";

function AccountDeactivated() {
    const [copied, setCopied] = useState(false);
    const salesEmail = "sales@geriactive.life";

    const handleCopy = () => {
        navigator.clipboard.writeText(salesEmail).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        });
    };

  return (
    <div className="deactivated-container">
      <div className="deactivated-card">
        <div className="icon">💔</div>
        <h1>Your free trial has ended...</h1>
        <p className="message">We're sad to see you go.</p>
        <p className="sub-message">We'll miss you — hope to see you again!</p>
        <div className="buttons">
            <button className="primary" onClick={handleCopy}>
              {copied ? "Copied!" : "Click to Copy Sales Email"}
            </button>
          <button className="secondary" onClick={() => window.location.href = "/login"}>
            Return to Login
          </button>
        </div>
         <br />
         <p className="message" style={{fontSize:'12px'}}>If you believe that this is in error, please contact our support team at <a href='mailto:support@geriactive.life'>support@geriactive.life</a> and they will assist you.</p>
      </div>
    </div>
  )
}

export default AccountDeactivated